/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Marionette = require('backbone.marionette');

var Session = require('psa-core/Session');

var MomentCell = require('common/backgrid/MomentCell');
var ButtonLinkCell = require('common/backgrid/ButtonLinkCell');
var moment = require('moment');

var COCInternalSidebarNavView = require('./COCInternalSidebarNavView');

require('../styles/COCInternalMyEventsView.css');
var tmplCOCInternalMyEventsView = require('../templates/COCInternalMyEventsView.hbs');
var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');
var Syphon = require('backbone.syphon');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCInternalMyEventsView,

  className: 'coc-internal-my-events-view container-fluid',

  ui: {
    sideBar: '.side-bar-container',
    myEvents: '.my-events-container',
    search: '.search',
    dateInputs: '.input-daterange'
  },

  regions: {
    sideBar: '@ui.sideBar',
    myEvents: '@ui.myEvents'
  },

  events: {
    'click @ui.search': 'onClickSearch'
  },

  templateHelpers: function() {
    return {
      startDate: moment().format('MM/DD/YYYY')
    };
  },

  onBeforeShow: function() {
    this.showChildView('sideBar', new COCInternalSidebarNavView());
    var events = this.model.get('events');
    var startDate = moment().format('MM/DD/YYYY');
    events = _.filter(events, function(event) {
      return event.endDateTime.isSameOrAfter(moment(startDate, 'MM/DD/YYYY'), 'day');
    });

    this.ui.dateInputs.datepicker();

    this.myEventsGrid = new GridView({
      columns: [
        {
          name: 'title',
          label: 'Event Name',
          cell: 'string',
          headerCell: 'custom',
          width: 35,
          editable: false
        },
        {
          name: 'startDateTime',
          label: 'Event Date',
          cell: MomentCell.MomentCell,
          formatter: MomentCell.MomentDateTimeFormatter.extend({
            emptyValue: '--'
          }),
          sortValue: MomentCell.MomentSortValue,
          headerCell: 'custom',
          width: 20,
          editable: false
        },
        {
          name: 'presenters',
          label: 'Presenters',
          cell: 'string',
          headerCell: 'custom',
          width: 20,
          editable: false
        },
        {
          name: 'createdDate',
          label: 'Created Date',
          cell: MomentCell.MomentCell,
          formatter: MomentCell.MomentDateFormatter.extend({
            emptyValue: '--'
          }),
          sortValue: MomentCell.MomentSortValue,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: '',
          label: '',
          cell: ButtonLinkCell.extend({
            name: 'Open',
            buttonClass: 'btn-primary btn-sm',
            href: function(model) {
              return '#coc/event/' + model.get('id');
            }
          }),
          headerCell: 'custom',
          width: 10,
          editable: false,
          sortable: false
        }
      ],
      collection: new PageableCollection(events, { pageSize: 10 }),
      emptyText: 'No Events'
    });
    this.showChildView('myEvents', this.myEventsGrid);
  },

  onClickSearch: function(e) {
    e.preventDefault();
    var filter = Syphon.serialize(this);
    var events = this.model.get('events');
    if (filter.eventDateStart) {
      events = _.filter(events, function(event) {
        return event.endDateTime.isSameOrAfter(moment(filter.eventDateStart, 'MM/DD/YYYY'), 'day');
      });
    }

    if (filter.eventDateEnd) {
      events = _.filter(events, function(event) {
        return event.startDateTime.isSameOrBefore(moment(filter.eventDateEnd, 'MM/DD/YYYY'), 'day');
      });
    }

    if (filter.selfPresenter === '1') {
      events = _.filter(events, function(event) {
        return event.presenters.includes(Session.user.description);
      });
    }

    this.myEventsGrid.collection.fullCollection.reset(events);
  }
});
